import { type HTMLAttributes, forwardRef } from 'react';
import { cn } from '@/lib/utils';

export const Card = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...rest }, ref) => (
    <div
      ref={ref}
      className={cn('rounded-2xl bg-tg-secondaryBg p-4 shadow-sm', className)}
      {...rest}
    />
  ),
);
Card.displayName = 'Card';
